module.exports = __webpack_public_path__ + "img/user-outlined.ad650a85.svg";